import { Fragment, useEffect } from 'react'
import { useTranslation } from 'next-i18next'

import Avatar2D from '~/components/Avatar2D'
import { InputDashboard } from '~/components/InputDashboard'
import useCurrentUser from '~/hooks/useCurrentUser'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'

import { UserField } from '~/types/user'

import ROUTES from '~/shared/constants/routes.const'

import UserUpdateButtons from '../components/UserUpdateButtons'

import {
  selectErrors,
  selectFields,
  selectIsServerErrorInNicknameTab,
  setFieldValueActionCreator,
} from '../redux/settings.slice'
import ServerError from '../components/ServerError'

export function AvatarNicknameTab(): React.ReactElement {
  const { t } = useTranslation(['fields', 'settings'])
  const user = useCurrentUser()

  const dispatch = useAppDispatch()

  const userNickname = user?.nickname || ''

  const fields = useAppSelector(selectFields)
  const errors = useAppSelector(selectErrors)
  const isServerErrorInNicknameTab = useAppSelector(selectIsServerErrorInNicknameTab)

  useEffect(() => {
    if (userNickname) {
      dispatch(setFieldValueActionCreator({ fieldName: UserField.NICKNAME, value: userNickname }))
    }
  }, [dispatch, userNickname])

  const handleOnInputChange = (name: string): void => {
    dispatch(setFieldValueActionCreator({ fieldName: UserField.NICKNAME, value: name }))
  }

  return (
    <Fragment>
      <div className="flex flex-col">
        <div className="mb-2 lg:mb-4 flex justify-center">
          <Avatar2D
            avatarPngUrl={user?.avatarPngUrl}
            btnHref={`${ROUTES.AVATAR}?from=settings`}
            createAvatarButtonClasses="text-sm font-bold"
            createAvatarButtonSize="xx-small"
            dimension={150}
            editAvatarIcon="editIcon"
            showCreateAvatarButton
            showEditAvatarIcon
            sizeClassName="w-46 h-37.5"
          />
        </div>
        <InputDashboard
          autoComplete="given-name"
          errorMessage={errors?.nickname}
          label={t('fields:nickname')}
          name="nickname"
          onChange={handleOnInputChange}
          type="text"
          value={fields.nickname}
        />

        {isServerErrorInNicknameTab && <ServerError />}

        <UserUpdateButtons isInNicknameTab />
      </div>
    </Fragment>
  )
}
